/**
 * main.js — NexChat Entry Point
 *
 * Bootstraps the application.
 * All configuration lives in nexchat.js CONFIG block.
 */

import { boot } from './nexchat.js';

// Handle global unhandled errors gracefully
window.addEventListener('unhandledrejection', (event) => {
  console.error('[nexchat] Unhandled promise rejection:', event.reason);
});

// Boot the app
boot().catch((err) => {
  console.error('[nexchat] Fatal boot error:', err);
  document.getElementById('app').innerHTML = `
    <div style="
      display:flex;
      align-items:center;
      justify-content:center;
      height:100vh;
      background:#0f0f13;
      color:#9896b0;
      font-family:system-ui;
      flex-direction:column;
      gap:12px;
    ">
      <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="#6c3ef4" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      <div style="font-size:16px;color:#f0eeff;font-weight:600;">NexChat failed to start</div>
      <div style="font-size:13px;">${err.message || 'Unknown error'}</div>
      <button onclick="location.reload()" style="
        margin-top:8px;
        background:#6c3ef4;
        color:white;
        border:none;
        border-radius:8px;
        padding:10px 20px;
        font-size:14px;
        cursor:pointer;
      ">Reload</button>
    </div>
  `;
});

